"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const add_brackets_1 = require("./maps/add_brackets");
const even_odd_split_1 = require("./utilities/even_odd_split");
const url_transformer_1 = require("./utilities/url_transformer");
exports.urlRedirectEncoder = (leftBracket, rightBracket) => url_transformer_1.default(even_odd_split_1.evenOddSplit(encodeURIComponent, add_brackets_1.default(leftBracket, rightBracket)));
exports.default = exports.urlRedirectEncoder;
//# sourceMappingURL=url_redirect_encoder.js.map